
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { Input, Label, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './SquareCheckbox.css';
import PropTypes from "prop-types";


export const SquareCheckbox = ({
    value,
    valueChangeHandler,
    id,
    disabled,
    size = "small", // default
    checkClassName,
    checkboxClassName,
    label = false,
    icon = faCheck,
    name
}) => {
    return (
        <FormGroup check className={`custom-checkbox-wrapper ${checkboxClassName}`}>
            <Label
                check
                className="d-flex align-items-center"
                htmlFor={id}
                style={{ cursor: disabled ? "not-allowed" : "pointer" }}
            >
                <Input
                    id={id}
                    type="checkbox"
                    checked={value}
                    onChange={valueChangeHandler}
                    disabled={disabled}
                    className="d-none"
                    name={name}
                />
                <span
                    className={`custom-square-check ${size} ${value ? "checked" : ""} ${checkClassName}`}
                >
                    {value && (
                        <FontAwesomeIcon
                            size="sm"
                            icon={icon}
                            className="check-icon"
                        />
                    )}
                </span>
                {label && <span className="ms-2 ml-2">{label}</span>}
            </Label>
        </FormGroup>
    );
};

SquareCheckbox.propTypes = {
    value: PropTypes.bool.isRequired,
    valueChangeHandler: PropTypes.func.isRequired,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(["small", "medium", "large"]),
    checkClassName: PropTypes.string,
    checkboxClassName: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.node]),
    icon: PropTypes.object,
};

